module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/107-kwait-1d631032750b1a326906a7a1a0dabf19.svg";